import { Chip } from "matsuri-ui"
import { useTranslation } from "@/hooks/useTranslation"
import {
    GuestStayStatus,
    guestStayStatusColor,
    guestStayStatusLabel
} from "@/model/listingOccupancy"

export const GuestStayStatusChip = ({
    status
}: {
    status: GuestStayStatus
}) => {
    const { t } = useTranslation()
    return (
        <Chip
            variant="filled"
            style={{
                fontWeight: "bold",
                backgroundColor: guestStayStatusColor[status]
            }}
        >
            {t(guestStayStatusLabel[status])}
        </Chip>
    )
}
